/**
 * A custom money formatter.
 * This has been created to handle formatting "money" for input fields.
 * Reason for not using Intl.NumberFormat for input fields
 * is due to its aggressive formatting in certain cases.
 */
export const inputMoneyFormatter = (value: string) => {
  const containsFraction = value.includes('.');

  const [decimal, fraction] = value.split('.');

  const formattedDecimal = decimal
    .split('')
    .reverse()
    .reduce<string[]>((acc, curr, index) => {
      // Don't add a "," in the beginning
      if (index === 0) {
        return [curr];
      }

      // For each 3 numbers, separate with ","
      if (index % SEPARATOR_EACH === 0) {
        return [...acc, ',', curr];
      }

      // Base case, simply add number
      return [...acc, curr];
    }, [])
    .reverse()
    .join('');

  const formattedFraction = `${containsFraction ? '.' : ''}${fraction ?? ''}`;

  return `${formattedDecimal}${formattedFraction}`;
};

const SEPARATOR_EACH = 3;
